import { render, staticRenderFns } from "./DeleteTopicModal.vue?vue&type=template&id=412edb00&scoped=true&"
import script from "./DeleteTopicModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteTopicModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTopicModal.vue?vue&type=style&index=0&id=412edb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412edb00",
  null
  
)

component.options.__file = "DeleteTopicModal.vue"
export default component.exports